import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiRequest } from 'store/Misc/apiRequest';
import { setFormLoading } from 'store/slices/miscSlice';
import Input from 'components/Input';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import HeaderComponent from 'components/HeaderComponent';
import { HeadOfficeValidation } from 'pages/Settings/validation';
import { destructureErrorMessage, filterValues } from 'Helper';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import useStates from 'hooks/useStates';
import { mutate } from 'swr';
import GooglePlaces from 'components/GooglePlaces';
export default withTranslation()(function OfficeAddress({ t, info, countries }) {
  const { states } = useStates()
  const dispatch = useDispatch();
  const method = useForm({
    mode: 'all',
    resolver: yupResolver(HeadOfficeValidation)
  });
  const { reset, handleSubmit, watch } = method;
  const [edit, setEdit] = useState(false)
  useEffect(() => {
    reset({
      country_id: info?.country_id,
      state_id: info?.head_office_state_id,
      town: info?.head_office_city,
      street: info?.head_office_street,
      building: info?.head_office_building,
      address: info?.head_office_address,
      google_map_url: info?.google_map_url,
    });
  }, [info, reset]);
  useEffect(() => { if (watch('country_id')) mutate(`collections/countries/${watch('country_id')}`) }, [watch]);

  const fields = [
    [
      {
        name: 'country_id',
        label: t('settings.head_office.country_id'),
        options: countries ? filterValues({ options: countries, param: { value: 'id', label: 'name' } }) : [],
        defaultValue: { value: countries?.find(x => x?.name === info?.head_office_country)?.id, label: countries?.find(x => x?.name === info?.head_office_country)?.name },
      },
      {
        name: 'state_id',
        label: t('settings.head_office.state_id'),
        options: states ? filterValues({ options: states, param: { value: 'id', label: 'name' } }) : [],
        defaultValue: { value: states?.find(x => x?.name === info?.head_office_state)?.id, label: states?.find(x => x.name === info?.head_office_state)?.name }
      },
    ],
    [
      {
        name: 'town',
        label: t('settings.head_office.town.label'),
        placeholder: t('settings.head_office.town.placeholder')
      },
      {
        name: 'street',
        label: t('settings.head_office.street.label'),
        placeholder: t('settings.head_office.street.placeholder')
      },
    ],
    {
      name: 'building',
      label: t('settings.head_office.building.label'),
      placeholder: t('settings.head_office.building.placeholder')
    },
    {
      name: 'google_map_url',
      label: t('settings.head_office.location_url.label'),
      placeholder: t('settings.head_office.location_url.placeholder'),
      type: 'location'
    },
    {
      name: 'address',
      label: t('settings.head_office.address.label'),
      multiline: true,
      placeholder: t('settings.head_office.address.placeholder')
    }
  ]
  const submit = async (payload) => {
    if (edit) {
      dispatch(setFormLoading())
      try {
        await apiRequest({
          method: 'post',
          url: 'settings/business-info',
          payload: {
            head_office: payload,
          }
        });
        toast.success('Head office information updated successfully');
      } catch ({ message }) {
        destructureErrorMessage(message).map(msg => {
          return toast.error(msg, { autoClose: 15000 })
        })
      } finally {
        setEdit(false)
      }
      dispatch(setFormLoading('close'))
    } else {
      setEdit(true)
    }
  }
  return (
    <FormProvider {...method}>
      <form className="w-full bg-white py-8 px-4 md:px-12 rounded-xl mb-5 shadow-sm" onSubmit={handleSubmit(submit)}>
        <HeaderComponent title="Head office address"
          btnText={edit ? 'Save' : 'Edit'} btnClick={() => submit(watch())}
          cancelBtn={edit ? { text: 'Cancel', click: () => { setEdit(false) } } :  false}
        />
        <div className="w-full grid md:grid-cols-2 md:gap-5 gap-y-10 mb-5">
          {
            fields.map((field, index) => {
              return (
                <React.Fragment key={`${index}_`}>
                  {
                    field.length ? (
                      <>
                        {
                          field.map(singleField => {
                            return (
                              <Input
                                name={singleField.name}
                                label={singleField.label}
                                options={singleField?.options}
                                placeholder={singleField?.placeholder}
                                variant="outlined"
                                classList="w-full rounded-md"
                                key={singleField.name}
                                defaultValue={singleField?.defaultValue}
                                disabled={!edit}
                              />
                            )
                          })
                        }
                      </>
                    ) : (
                      field.type !== 'location' ? (
                        <Input
                          name={field.name}
                          label={field.label}
                          placeholder={field?.placeholder}
                          multiline={field?.multiline ?? false}
                          minRows={field?.multiline ? 3 : 1}
                          variant="outlined"
                          disabled={!edit}
                        />
                      ) : (
                        <GooglePlaces
                          name={field.name}
                          label={'Locaton Url'}
                          labelStyle={{ mb: '10px', fontSize: '12px' }}
                          getUrl={(data) => null}
                          disabled={!edit}
                        />
                      )
                    )
                  }
                </React.Fragment>
              )
            })
          }
        </div>
      </form>
    </FormProvider>
  )
});